import { ReactNode } from 'react';

import { IconText } from '@motorway/mw-highway-code';
import type { IconComponentFunction } from '@motorway/mw-highway-code/src/components/Icon/Icon.types';
import { THCComponentProps } from '@motorway/mw-highway-code/src/types';
import { filterDataProps } from '@motorway/mw-highway-code/src/utils/helpers';

import { Frame } from '../Frame/Frame';

import styles from './HeadingBanner.module.scss';

interface HeadingBannerProps {
  action?: ReactNode;
  children?: ReactNode;
  description: ReactNode;
  icon?: IconComponentFunction;
  title: ReactNode;
}

export const HeadingBanner = (
  { action, children, description, icon, title, ...rest }: THCComponentProps<HeadingBannerProps>,
) => {
  const dataProps = filterDataProps(rest);

  return (
    <Frame data-testid="headingBanner" {...dataProps}>
      <div className={styles.contentWrapper}>
        <div className={styles.mainContent}>
          <div className={styles.textContent}>
            <div className={styles.headingWrapper}>
              <h1 className={styles.title}>
                {icon ? (
                  <IconText
                    icon={icon}
                    text={title || ''}
                    variant={'small--regular'}
                  />
                ) : title }
              </h1>
            </div>
            <p data-thc-style-override className={styles.description}>{description}</p>
          </div>
          {action && <div className={styles.actionWrapper}>{action}</div>}
        </div>
        {children}
      </div>
    </Frame>
  );
};
